import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterpolationService, parseCSV, TableRow } from 'map-wald';
import { map, Observable, of } from 'rxjs';
import { TerrakioLayerMin } from './terrakio-layer';

const DATA_COLUMNS=['date','value'];

@Injectable()
export class TimeSeriesService {
  defaultEndpoint: string;

  constructor(private http:HttpClient) { }

  forPolygon(geoJSON: any, layer: TerrakioLayerMin): Observable<TableRow[]> {
    geoJSON = cleanFeature(geoJSON);
    let v = layer.variable || layer.shortVariable;
    let expression = '';
    if(layer.script){
      expression = InterpolationService.interpolate((layer.script||[]).join('\n'),{
        timeRequest:'',
        requestVariable:v
      }) + '\n';
    } else {
      v = `${layer.collection}.${v}`;
    }
    expression += `mean:space(${v})`;
    console.log('EXPRESSION POLYGON DRILL:\n',expression);

    const result$ = this.http.post(layer.polygonDrill||this.defaultEndpoint,{
      feature:{...geoJSON,properties:{}},
      output: 'csv',
      name:layer.collection,
      products:[v],
      in_crs:'epsg:4326',
      out_crs:'epsg:4326',
      resolution: layer.resolution||-1,
      expr:expression
    }, {
      headers: layer.polygonDrillHeaders||{},
      responseType:'text'
    }).pipe(
      map(res=>{
        const data = parseCSV(res,{
          columns:DATA_COLUMNS,
          headerRows:1
        });
        return data;
      }));
    return result$;
  }
}

export function cleanFeature(geoJSON:any):any {
  let points:number[][][] = geoJSON.geometry.coordinates;
  let shiftEast = false;
  let shiftWest = false;
  do{
    shiftEast = points.every(poly=>poly.every(point=>point[0]<-180));
    shiftWest = points.every(poly=>poly.every(point=>point[0]>180));

    const shift = function(direction:number) {
      return points.map(poly=>poly.map(point=>[point[0]+direction,point[1]]));
    };

    if(shiftEast){
      points = shift(360);
    } else if(shiftWest){
      points = shift(-360);
    }
  } while(shiftEast||shiftWest);

  geoJSON.geometry.coordinates = points;
  return geoJSON;
}
